import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseCollectionResult } from '@hooks/dashboard/useCollection'
import { HYGIENE_PLACEHOLDER } from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTileItem } from '../../FinanceMetricTiles.component'
import { dashboardFinanceMetricFooter } from '../shared/dashboardFinanceMetricFooter'

type CollectionMetricCardProps = {
  titleHref: string
  collection: UseCollectionResult
}

export function CollectionMetricCard({
  titleHref,
  collection,
}: CollectionMetricCardProps): React.ReactElement {
  const {
    loading,
    hasPayload,
    hasGrossData,
    summary,
    grossStr,
    collectionMetricGoalLabel: goalLabel,
  } = collection
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasGrossData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Collection"
      titleHref={titleHref}
      className="dashboard-finance-metric-card"
      loading={pending}
      skeleton={{ metrics: 1, block: 'none' }}
      isEmpty={isEmpty}
    >
      <FinanceMetricTileItem
        leftLabel="Collection"
        value={loading ? HYGIENE_PLACEHOLDER : grossStr}
        rightLabel={goalLabel}
        footer={
          summary
            ? dashboardFinanceMetricFooter(summary.grossCollection)
            : undefined
        }
      />
    </DashboardSectionCard>
  )
}
